import { BsFillLayersFill } from "react-icons/bs";
import { FaFolderOpen } from "react-icons/fa";
import { IoSettingsOutline } from "react-icons/io5";
import { BsRobot } from "react-icons/bs";

export const pageTitle = {
  "/chat": {
    title: "Multi-provider AI Chat",
    icon: null
  },
  "/chat/": {
    title: "Multi-provider AI Chat",
    icon: null

  },
  "/knowledge-base": {
    title: "Knowledge Base",
    icon: <FaFolderOpen />
  },
  "/config": {
    title: "Settings",
    icon: <IoSettingsOutline />
  },
  "/agentsList": {
    title: "Agent Lists",
    icon: <BsRobot />
  },
  "/users-agents": {
    title: "Agent Lists",
    icon: <BsRobot />
  },
  "/public-agent" : {
    title: "Explore Agents",
    icon: <BsFillLayersFill />
  }
};
